import request from '@/utils/request'
import router from '../../router'

export default {
	login: async({ dispatch, commit }, user) => {
		await request({ method: 'post', url: '/sessions', data: user })
			.then(res => {
				if (res.data && res.data.token) {
					commit('SET_TOKEN', res.data.token)

					if (!res.data.confirmed) {
						commit('SET_CONFIRMED_CODE_LENGTH', res.data['confirmCodeFormat.length'] || 4)

						dispatch('addMessage', {
							message: 'pushLoginCode',
							type: 'info',
							locale: true
						})
					} else {
						commit('SET_CONFIRMED', Boolean(res.data.confirmed))
					}
				}
			}).catch(err => {
				dispatch('addMessage', {
					message: err && err.message,
					debug: true
				})
			})
	},

	confirmed: async({ dispatch, commit, state }, data) => {
		await request({ method: 'post', url: '/sessions/confirmation', data })
			.then(res => {
				if (res && res.data && res.data.confirmed) {
					commit('SET_CONFIRMED', true)

					dispatch('addMessage', {
						message: 'login',
						type: 'success',
						locale: true
					})

					router.push('/dashboard')
				} else if (res && res.response && res.response.status == 409) {
					dispatch('addMessage', {
						message: 'incorrectConfirmCode',
						type: 'error',
						locale: true
					})
				}
			}).catch(err => {
				dispatch('addMessage', {
					message: err && err.message,
					debug: true
				})
			})
	},

	logout: async({ commit, dispatch }) => {
		await request({ method: 'delete', url: '/sessions' })
			.then(res => {
				commit('REMOVE_TOKEN', res.data.profile)
				commit('SET_CONFIRMED', false)
			}).catch(err => {
				dispatch('addMessage', {
					message: err && err.message,
					debug: true
				})
			})
	},

	getCities: async({ commit, dispatch, state }) => {
		await request({ method: 'get', url: '/ukr/cities' })
			.then(res => {
				if (res.data && res.data.length) {
					commit('SET_CITIES', res.data)

					if (!state.defaultCity) {
						const defaultCity = window.cityCode ? res.data.find(it => it.code == window.cityCode) : res.data[0]
						commit('SET_DEFAULT_CITY', defaultCity || res.data.find(it => it.code === 'vin'))
					} else {
						const existDefaultCity = res.data.findIndex(it => it.code == state.defaultCity.code)

						if (existDefaultCity == -1) {
							commit('SET_DEFAULT_CITY', res.data[0])
						}
					}
				}
			})
			.catch(err => {
				dispatch('addMessage', {
					message: err.message,
					debug: true
				})
			})
	},

	toggleDevice({ commit }, device) {
		commit('TOGGLE_DEVICE', device)
	},

	setLanguage({ commit }, language) {
		commit('SET_LANGUAGE', language)
	}
}
